import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import MovieCard from '@/components/base/MovieCard';
import SEOMeta from '@/components/base/SEOMeta';
import SchemaOrg from '@/components/base/SchemaOrg';
import { categories, featuredMovies, hotMovies, newMovies } from '@/mocks/movies';

export default function Home() {
  return (
    <>
      <SEOMeta
        title="屁屁影院 - 免费在线观影平台 | 高清电影电视剧动漫在线观看"
        description="屁屁影院是一款免费在线观影平台，提供海量高清电影、电视剧、动漫资源，无需注册即可畅享流畅播放体验。支持多线路切换，资源更新及时，是您追剧看电影的首选娱乐平台。"
        keywords="屁屁影院,屁屁影院在线观看,屁屁影院免费电影,屁屁影院高清资源,屁屁影院最新电视剧,屁屁影院动漫,屁屁影院官网入口"
      />
      <SchemaOrg
        type="WebPage"
        data={{
          name: '屁屁影院 - 首页',
          description: '免费在线观影平台，提供海量高清电影、电视剧、动漫资源',
          url: 'https://www.ppcinema.com',
        }}
      />

      <ScrollToTop />
      <Navbar />

      <main>
        <section className="relative h-[450px] md:h-[600px] flex items-center justify-center overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=dark%20cinematic%20movie%20theater%20atmosphere%20with%20warm%20golden%20and%20red%20ambient%20light%2C%20abstract%20film%20reel%20and%20curtains%2C%20dramatic%20lighting%2C%20luxurious%20theater%20interior%2C%20elegant%20composition&width=1920&height=1080&seq=pipi-hero-bg&orientation=landscape"
            alt="屁屁影院 - 免费在线观影平台"
            title="屁屁影院 - 免费在线观影平台"
            className="absolute inset-0 w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/60"></div>

          <div className="relative z-10 text-center px-4 w-full max-w-3xl mx-auto">
            <h1 className="text-3xl md:text-5xl font-bold text-white mb-4 font-heading leading-tight">
              屁屁影院 - 免费在线观影平台
            </h1>
            <p className="text-base md:text-lg text-white/80 mb-8 max-w-xl mx-auto leading-relaxed">
              海量高清电影、电视剧、动漫资源，无需注册，随时随地畅享流畅播放体验
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
              <Link
                to="/category/movie"
                className="px-8 py-3 bg-primary-500 text-white rounded-full font-medium text-sm hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-film-line mr-2"></i>
                开始观影
              </Link>
              <Link
                to="/about"
                className="px-8 py-3 bg-white/10 backdrop-blur-sm text-white border border-white/20 rounded-full font-medium text-sm hover:bg-white/20 transition-all duration-300 whitespace-nowrap cursor-pointer"
              >
                了解更多
              </Link>
            </div>
          </div>
        </section>

        <section className="px-4 md:px-6 py-10 md:py-14 max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
            {categories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className="group relative overflow-hidden rounded-xl p-6 md:p-8 bg-background-100 hover:bg-background-200/70 transition-all duration-300 cursor-pointer"
              >
                <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-primary-100 text-primary-500 mb-4 group-hover:bg-primary-500 group-hover:text-white transition-all duration-300">
                  <i className={`${cat.icon} text-xl`}></i>
                </div>
                <h3 className="text-lg font-semibold text-foreground-900 mb-2 font-heading">{cat.name}</h3>
                <p className="text-sm text-foreground-500 leading-relaxed">{cat.description}</p>
                <div className="mt-4 flex items-center gap-1 text-sm text-primary-500 font-medium">
                  <span>立即观看</span>
                  <i className="ri-arrow-right-line text-xs group-hover:translate-x-1 transition-transform"></i>
                </div>
              </Link>
            ))}
          </div>
        </section>

        <section className="px-4 md:px-6 py-10 md:py-14 bg-background-100">
          <div className="max-w-7xl mx-auto">
            <div className="flex items-center justify-between mb-6 md:mb-8">
              <div>
                <h2 className="text-xl md:text-2xl font-bold text-foreground-900 font-heading">
                  <i className="ri-fire-line text-accent-500 mr-2"></i>
                  热门推荐
                </h2>
                <p className="text-sm text-foreground-500 mt-1">大家都在看的精彩内容</p>
              </div>
              <Link
                to="/category/movie"
                className="text-sm text-primary-500 hover:text-primary-600 font-medium whitespace-nowrap cursor-pointer flex items-center gap-1"
              >
                查看更多 <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
            <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-5" data-product-shop>
              {featuredMovies.map((movie) => (
                <MovieCard key={movie.id} {...movie} />
              ))}
            </div>
          </div>
        </section>

        <section className="px-4 md:px-6 py-10 md:py-14 max-w-7xl mx-auto">
          <div className="flex items-center justify-between mb-6 md:mb-8">
            <div>
              <h2 className="text-xl md:text-2xl font-bold text-foreground-900 font-heading">
                <i className="ri-time-line text-primary-500 mr-2"></i>
                最新更新
              </h2>
              <p className="text-sm text-foreground-500 mt-1">实时更新，精彩不断</p>
            </div>
          </div>
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5" data-product-shop>
            {newMovies.map((movie) => (
              <MovieCard key={movie.id} {...movie} />
            ))}
          </div>
        </section>

        <section className="px-4 md:px-6 py-10 md:py-14 bg-background-100">
          <div className="max-w-7xl mx-auto">
            <div className="text-center mb-8 md:mb-10">
              <h2 className="text-xl md:text-2xl font-bold text-foreground-900 font-heading mb-2">
                为什么选择屁屁影院？
              </h2>
              <p className="text-sm text-foreground-500 max-w-lg mx-auto">
                六大特色功能，为您打造极致的在线观影体验
              </p>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
              <FeatureCard
                icon="ri-movie-2-line"
                title="海量资源"
                desc="收录超过10万部电影、电视剧、动漫资源，涵盖国内外各类题材。"
              />
              <FeatureCard
                icon="ri-4k-line"
                title="高清画质"
                desc="支持HD高清、4K超清多种画质，多线路切换确保最佳观影效果。"
              />
              <FeatureCard
                icon="ri-speed-up-line"
                title="极速播放"
                desc="先进CDN加速技术，全国多节点部署，播放流畅不卡顿。"
              />
              <FeatureCard
                icon="ri-refresh-line"
                title="更新及时"
                desc="24小时跟踪最新影视动态，热门剧集播出后2小时内更新。"
              />
              <FeatureCard
                icon="ri-device-line"
                title="多端适配"
                desc="完美适配PC、平板、手机等设备，随时随地畅享观影。"
              />
              <FeatureCard
                icon="ri-shield-check-line"
                title="安全无广告"
                desc="绿色安全无弹窗，纯净观影环境，保护用户隐私安全。"
              />
            </div>
          </div>
        </section>

        <section className="px-4 md:px-6 py-10 md:py-14 max-w-7xl mx-auto">
          <div className="bg-gradient-to-br from-primary-500 to-accent-500 rounded-2xl p-8 md:p-12 text-center">
            <h2 className="text-xl md:text-2xl font-bold text-white mb-3 font-heading">
              立即开始您的观影之旅
            </h2>
            <p className="text-white/80 text-sm mb-6 max-w-md mx-auto">
              无需注册，无需付费，打开即看。海量影视资源等您来发现！
            </p>
            <Link
              to="/category/movie"
              className="inline-flex items-center px-8 py-3 bg-white text-primary-600 rounded-full font-medium text-sm hover:bg-white/90 transition-all whitespace-nowrap cursor-pointer"
            >
              <i className="ri-play-circle-line mr-2"></i>
              开始免费观影
            </Link>
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
}

function FeatureCard({ icon, title, desc }: { icon: string; title: string; desc: string }) {
  return (
    <div className="flex gap-4 p-5 rounded-xl bg-background-50 border border-background-200/70">
      <div className="w-10 h-10 flex-shrink-0 flex items-center justify-center rounded-lg bg-primary-100 text-primary-500">
        <i className={`${icon} text-lg`}></i>
      </div>
      <div>
        <h3 className="text-sm font-semibold text-foreground-900 mb-1 font-heading">{title}</h3>
        <p className="text-xs text-foreground-500 leading-relaxed">{desc}</p>
      </div>
    </div>
  );
}